import React from 'react';
import ReactDOM from 'react-dom';
import { MapModuleButton } from '../../../mapping/mapmodule/MapModuleButton';
import { QuestionOutlined } from '@ant-design/icons';
import { showMapLegendPopup } from './MapLegendPopup';
Oskari.clazz.define('Oskari.mapframework.bundle.maplegend.plugin.MapLegendPlugin', function (config) {
  this._config = config || {};
  this._clazz = 'Oskari.mapframework.bundle.maplegend.plugin.MapLegendPlugin';
  this._defaultLocation = 'top right';
  this._index = 90;
  this._popupControls = null;
}, {
  resetUI: function resetUI() {
    if (this.isOpen()) {
      this.clearPopup();
    }
  },
  _startPluginImpl: function _startPluginImpl() {
    this.addToPluginContainer(this._createControlElement());
    this.refresh();
    return true;
  },
  _stopPluginImpl: function _stopPluginImpl() {
    this.clearPopup();
    this.removeFromPluginContainer(this.getElement());
  },
  _createControlElement: function _createControlElement() {
    return jQuery('<div class="mapplugin maplegend"></div>').clone();
  },
  clearPopup: function clearPopup() {
    if (this._popupControls) {
      this._popupControls.close();
    }
    this._popupControls = null;
    this.refresh();
  },
  refresh: function refresh() {
    var _this = this;
    var el = this.getElement();
    if (!el) {
      return;
    }
    var title = Oskari.getMsg('maplegend', 'tooltip');
    ReactDOM.render(/*#__PURE__*/React.createElement(MapModuleButton, {
      className: "t_maplegend",
      title: title,
      icon: /*#__PURE__*/React.createElement(QuestionOutlined, null),
      onClick: function onClick() {
        return _this.togglePopup();
      },
      iconActive: this.isOpen(),
      position: this.getLocation()
    }), el[0]);
  },
  getLegend: function getLegend(legendId) {
    var layer = Oskari.getSandbox().findMapLayerFromSelectedMapLayers(legendId);
    if (!layer) {
      return;
    }
    return layer.getLegendImage();
  },
  togglePopup: function togglePopup() {
    var _this2 = this;
    if (this.isOpen()) {
      this.clearPopup();
      return;
    }
    var legends = this.getLegends();
    this._popupControls = showMapLegendPopup(legends, function (id) {
      return _this2.getLegend(id);
    }, function () {
      return _this2.clearPopup();
    });
    this.refresh();
  },
  getLegends: function getLegends() {
    return this.getSandbox().findAllSelectedMapLayers().filter(function (layer) {
      return layer.getLegendImage();
    }).map(function (layer) {
      return {
        id: layer.getId(),
        title: Oskari.util.sanitize(layer.getName())
      };
    });
  },
  isOpen: function isOpen() {
    return !!this._popupControls;
  }
}, {
  extend: ['Oskari.mapping.mapmodule.plugin.BasicMapModulePlugin'],
  /**
   * @static @property {string[]} protocol array of superclasses
   */
  protocol: ['Oskari.mapframework.module.Module', 'Oskari.mapframework.ui.module.common.mapmodule.Plugin']
});